$mynamespace_myapp_button $mol_button_major
